export interface PollingManagerOptions {
  interval: number
  onTick: () => void
  isVisible?: () => boolean
}

export interface PollingManager {
  subscribe: () => void
  unsubscribe: () => void
}

export function createPollingManager(options: PollingManagerOptions): PollingManager {
  const { interval, onTick, isVisible = () => document.visibilityState === 'visible' } = options

  let refCount = 0
  let intervalId: ReturnType<typeof setInterval> | null = null

  function onVisibilityChange() {
    if (isVisible() && refCount > 0) {
      scheduleIdleCallback(onTick, { timeout: 100 })
    }
  }

  function start() {
    if (intervalId !== null)
      return

    intervalId = setInterval(() => {
      if (isVisible()) {
        scheduleIdleCallback(onTick, { timeout: interval })
      }
    }, interval)

    document.addEventListener('visibilitychange', onVisibilityChange)
  }

  function stop() {
    if (intervalId !== null) {
      clearInterval(intervalId)
      intervalId = null
    }
    document.removeEventListener('visibilitychange', onVisibilityChange)
  }

  function subscribe() {
    refCount++
    if (refCount === 1) {
      start()
    }
  }

  function unsubscribe() {
    refCount = Math.max(0, refCount - 1)
    if (refCount === 0) {
      stop()
    }
  }

  return { subscribe, unsubscribe }
}
